import React, { useState, useRef, useEffect } from "react";
import "./index.scss";
import { Avatar } from "fds";
import classNames from "classnames";
import { Workgroup } from "../../types/workgroup";
interface WorkgroupAvatarProps {
  item?: Workgroup;
  classes?: string;
  size?: "20" | "24" | "32" | "40" | "48";
  type?: "sidemenu" | "normal";
}
export const pickColor = (id: string, rootWorkgroupId?: string): any => {
  const colors =
    !rootWorkgroupId || rootWorkgroupId === id
      ? ["deepGreen", "deep_cyan", "deep_blue", "deep_purple", "navy"]
      : ["green", "cyan", "blue", "purple", "deep_navy"];
  const uniqueId =
    !rootWorkgroupId || rootWorkgroupId === id ? id : rootWorkgroupId;
  return id === "NONEWORKGROUP"
    ? "gray"
    : colors[
        (uniqueId.charCodeAt(0) + uniqueId.charCodeAt(uniqueId.length - 1)) %
          colors.length
      ];
};

const WorkgroupAvatar: React.FC<WorkgroupAvatarProps> = ({
  item,
  size,
  type,
  classes,
}) => {
  return item ? (
    <Avatar
      name={
        item.workgroupId === "NONEWORKGROUP" ? "My Box" : item.workgroupName
      }
      size={size ?? "32"}
      shape="workgroup"
      uniqueCode={item?.workgroupId}
      color={
        pickColor(
          item?.workgroupId,
          "rootWorkgroupId" in item ? item?.rootWorkgroupId : undefined
        ) ?? "green"
      }
      opacity={
        type &&
        (item?.isValidate === 0 ||
          ("workgroupJoined" in item && item?.workgroupJoined === false)) &&
        !window.location.href.includes(item?.workgroupId)
          ? "20%"
          : "100%"
      }
      classes={classNames("WorkgroupAvatar", classes)}
    />
  ) : (
    <></>
  );
};
export default WorkgroupAvatar;
